// @ts-expect-error This package is not typed.
import { nGMCA } from 'ml-ngmca';
import { estimateNbPureComponents } from "../util/estimate_nb_pure_components.js";
/**
 * Performing non-negative matrix factorization solving argmin_(A >= 0, S >= 0) 1 / 2 * ||Y - AS||_2^2 + lambda * ||S||_1
 * @param chromatogram - GC/MS chromatogram where make the estimation.
 * @param options - Options of ngmca factorization method
 */
export function deconvolution(chromatogram, options) {
    let { rank } = options;
    const { range, nmfOptions = {} } = options;
    const { matrix, mzAxis, times } = chromatogram.getMzVsTimesMatrix(range);
    if (!rank)
        rank = estimateNbPureComponents(chromatogram, { range, matrix });
    if (rank < 1) {
        throw new RangeError(`Rank should be a positive number for ${range.from} - ${range.to}`);
    }
    const result = nGMCA(matrix, rank, nmfOptions);
    const maxByRow = [];
    for (let i = 0; i < result.S.rows; i++) {
        maxByRow.push(result.S.maxRow(i));
    }
    result.S.scale('row', { scale: maxByRow });
    result.A.scale('column', {
        scale: maxByRow.map((e) => 1 / e),
    });
    return {
        matrix,
        times,
        mzAxis,
        rank,
        profile: result.A,
        component: result.S,
    };
}
//# sourceMappingURL=deconvolution.js.map